import constants from '@/util/constants.js'

const obterRota = (tipoDeAcesso, modulo) => {
  switch (tipoDeAcesso) {
    case constants.tipoDeAcessoDoUsuario.administrador:
    case constants.tipoDeAcessoDoUsuario.gestorDeConteudo:
      return modulo + '-administracao'

    default:
      return modulo
  }
}

export default {
  obterRota
}
